import { useCallback, useContext, useEffect, useReducer, useRef, useState } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
const sameId = (a, b) => String(a) === String(b);
export const reducer = (state, action) => {
  const item = action.payload;
  if (action.type === "LOAD_WHATSAPPS") return Array.isArray(item) ? item : [];
  if (action.type === "RESET") return [];
  if (action.type === "DELETE_WHATSAPPS") return state.filter(row => !sameId(row.id, item));
  if (action.type === "UPDATE_WHATSAPPS" && item?.id) return state.some(row => sameId(row.id, item.id)) ? state.map(row => sameId(row.id, item.id) ? { ...row, ...item } : row) : [item, ...state];
  if (action.type === "UPDATE_SESSION" && item?.id) return state.map(row => sameId(row.id, item.id) ? { ...row, ...item } : row);
  return state;
};
export default function useWhatsApps() {
  const { user, socket } = useContext(AuthContext);
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const pending = useRef(null);
  const sequence = useRef(0);
  const companyId = user?.companyId;
  const reload = useCallback(async () => {
    if (!companyId) return;
    const request = ++sequence.current;
    const events = []; pending.current = events;
    setLoading(true); setError(false);
    try {
      const { data } = await api.get("/whatsapp/?session=0", { timeout: 20000 });
      if (request !== sequence.current) return;
      dispatch({ type: "LOAD_WHATSAPPS", payload: events.reduce(reducer, Array.isArray(data) ? data : []) });
    } catch (_) { if (request === sequence.current) setError(true); }
    finally { if (request === sequence.current) { pending.current = null; setLoading(false); } }
  }, [companyId]);
  useEffect(() => {
    dispatch({ type: "RESET" }); reload();
    return () => {
      // Invalidate in-flight requests, including manual refreshes after this effect started.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      sequence.current++; pending.current = null;
    };
  }, [reload]);
  useEffect(() => {
    if (!companyId || typeof socket?.on !== "function" || typeof socket?.off !== "function") return undefined;
    const send = action => { if (pending.current) pending.current.push(action); dispatch(action); };
    const updated = data => {
      if (data.action === "update") send({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
      if (data.action === "delete") send({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
    };
    const session = data => { if (data.action === "update") send({ type: "UPDATE_SESSION", payload: data.session }); };
    socket.on(`company-${companyId}-whatsapp`, updated);
    socket.on(`company-${companyId}-whatsappSession`, session);
    return () => { socket.off(`company-${companyId}-whatsapp`, updated); socket.off(`company-${companyId}-whatsappSession`, session); };
  }, [socket, companyId]);
  return { whatsApps, loading, error, reload };
}